module.exports = __webpack_public_path__ + "static/donbranco_mainloop-eda0a94b9a35ad7f31d735d0ed179960.mp4";